<div class="page-container">
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">tune</mat-icon>
      <div>
        <div class="page-title">{{ pageLabel }}</div>
      </div>
    </div>
    <div class="total-badge">
      <mat-icon class="badge-icon">tune</mat-icon>
      <div class="badge-content">
        <span class="badge-label">Total {{ pageLabel | lowercase }}</span>
        <span class="badge-value">{{ totalCount }}</span>
      </div>
    </div>
  </div>

  <div class="search-bar-row">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix class="search-icon">search</mat-icon>
      <input
        matInput
        placeholder="Type {{ pageLabel | lowercase }} name to find"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch()"
        [attr.aria-label]="'Search ' + (pageLabel | lowercase)"
      />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z2 table-card">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      aria-label="Fee & Allowances"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="term">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Term</th>
        <td mat-cell *matCellDef="let row">{{ row.term }}</td>
      </ng-container>

      <ng-container matColumnDef="rate">
        <th mat-header-cell *matHeaderCellDef>Rate</th>
        <td mat-cell *matCellDef="let row">{{ row.rate }}</td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
        <td mat-cell *matCellDef="let row">{{ row.source }}</td>
      </ng-container>

      <ng-container matColumnDef="effectiveFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.effectiveFrom ? (row.effectiveFrom | date:'MM/dd/yyyy') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="effectiveTo">
        <th mat-header-cell *matHeaderCellDef>End date</th>
        <td mat-cell *matCellDef="let row">Present</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        class="table-row clickable-row"
        (click)="onRowClick(row)"
        (keydown.enter)="onRowClick(row)"
        tabindex="0"
        [attr.aria-label]="'View details for ' + row.name"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          No fees or allowances found.
        </td>
      </tr>
    </table>

    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      aria-label="Select page"
    ></mat-paginator>
  </div>

  <div class="footer-actions">
    <button mat-stroked-button class="go-back-btn" (click)="goBack()" aria-label="Go back">
      GO BACK
    </button>
  </div>
</div>
